interface State {
    hideUnusedGroups?: number;
}

const selectHideUnusedGroups = (state: State) => state.hideUnusedGroups;

export { selectHideUnusedGroups };
